import React from 'react'
import { connect } from 'react-redux'
import { Editor } from '@tinymce/tinymce-react'
import InsuranceActions from '../../Redux/InsuranceRedux'

class UpdateTicketPackage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      form: {
        name: props.detail.name || '',
        price: props.detail.price || 0,
        start_amount: props.detail.start_amount || 0,
        end_amount: props.detail.end_amount || 0,
        description: props.detail.description || ''
      }
    }
  }

  _inputChange = (event, field) => {
    let val = ''
    if (field === 'description') {
      val = event.target.getContent()
    } else {
      val = event.target.value
    }
    let form = {...this.state.form}
    form[field] = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = {...this.state.form}
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.put(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '70vw' }} >
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Ticket Package</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Package Name</label>
            </div>
            <div className='col-9'>
              <input type='text' required placeholder='Insert package name here' className='form-control' value={this.state.form.name} onChange={(event) => this._inputChange(event, 'name')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Package Price</label>
            </div>
            <div className='col-9'>
              <input type='number' min='0' required placeholder='Insert package price here' className='form-control' value={this.state.form.price} onChange={(event) => this._inputChange(event, 'price')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Start Amount</label>
            </div>
            <div className='col-9'>
              <input type='number' min='0' required placeholder='' className='form-control' value={this.state.form.start_amount} onChange={(event) => this._inputChange(event, 'start_amount')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>End Amount</label>
            </div>
            <div className='col-9'>
              <input type='number' min='0' required placeholder='' className='form-control' value={this.state.form.end_amount} onChange={(event) => this._inputChange(event, 'end_amount')} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Description</label>
            </div>
            <div className='col-9'>
              <Editor
                initialValue={this.state.form.description}
                init={{
                  plugins: 'table lists textcolor colorpicker',
                  menubar: false,
                  branding: false,
                  toolbar1: 'formatselect fontselect fontsizeselect | bold italic underline | forecolor backcolor',
                  toolbar2: 'alignleft aligncenter alignright | indent outdent | numlist bullist | table',
                  height: 350
                }}
                onChange={(event) => this._inputChange(event, 'description')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  put: (data) => dispatch(InsuranceActions.putTicketPackageRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateTicketPackage)



// WEBPACK FOOTER //
// ./src/Containers/Insurance/UpdateTicketPackage.js